import React from 'react';

const TaskPreviewModalLayout = ({ image }) => {
	return (
		<div className="task-preview-modal">
			<img src={image.src} alt="" />
		</div>
	);
};

export default TaskPreviewModalLayout;
